module.exports = "<bs-navbar></bs-navbar>\n\n<div class=\"container\"><router-outlet></router-outlet></div>\n"